// Min list view dimensions
export const MIN_LIST_VIEW_WIDTH: number = 350;
export const MIN_LIST_VIEW_HEIGHT: number = 150;

// Default list view dimensions, this should be greater or equal to the minimum list view dimensions
export const DEFAULT_LIST_VIEW_WIDTH: number = 350;
export const DEFAULT_LIST_VIEW_HEIGHT: number = 270;

// Max list view dimensions allowed
export const MAX_LIST_VIEW_WIDTH: number = 574;
export const MAX_LIST_VIEW_HEIGHT: number = 800;

// Min width of the window when dynamic layout is supported
export const MIN_WINDOW_WIDTH: number = 418;
